import { createContext, useContext } from 'react'

import { trackEmitter } from '@/hooks/analyticsData/helpers/trackEmitter'

const DiscoverTrackContext = createContext<string | undefined>(undefined)

export const DiscoverTrackProvider = DiscoverTrackContext.Provider

export function useDiscoverType() {
  return useContext(DiscoverTrackContext)
}

export function useDiscoverTrack(id: string) {
  const discoverType = useDiscoverType()

  const trackDiscover = (
    method: 'like_click' | 'play_click' | 'share_click',
    location = '',
  ) => {
    if (!discoverType) return
    trackEmitter.emit('track-event', {
      name: 'discover',
      method,
      id,
      type: discoverType,
      location,
    })
  }

  return { discoverType, trackDiscover }
}
